import {
  CubeReducerState,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

/**
 * Whether another amendment of this quote's schedule is out for signature or signed. Only one
 * can be at a time, so the backend won't send this one for signature or mark it as signed until
 * that one is executed, archived or expires.
 */
export const isAnotherAmendmentOutForSignature = (
  prevState: Pick<CubeReducerState, 'data'>
): boolean => Boolean(prevState.data.quote.amendment?.outForSignatureQuoteId)

/**
 * Takes a feature's own answer and switches it off while another amendment holds the signing
 * slot, keeping whatever that feature decided about `visible`, so the button stays put and its
 * tooltip can say why.
 */
export const disableIfAnotherAmendmentOutForSignature =
  (prevState: Pick<CubeReducerState, 'data'>) =>
  (feature: VisibleEnabledFeatureAvailable): VisibleEnabledFeatureAvailable => {
    if (!isAnotherAmendmentOutForSignature(prevState)) {
      return feature
    }

    return {
      available: {
        visible: feature.available.visible,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.AmendmentOutForSignature,
          metadata: {
            outForSignatureQuoteId:
              prevState.data.quote.amendment?.outForSignatureQuoteId
          }
        },
        ...feature.reasons
      ]
    }
  }
